import { render, staticRenderFns } from "./threeDchats.vue?vue&type=template&id=1a407a72"
import script from "./threeDchats.vue?vue&type=script&lang=js"
export * from "./threeDchats.vue?vue&type=script&lang=js"
import style0 from "./threeDchats.vue?vue&type=style&index=0&id=1a407a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports